var _excluded = ["desc", "focusable", "title", "iconName", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { string, bool } from 'prop-types';
import classNames from 'classnames';
var svg = /*#__PURE__*/React.createElement("svg", {
  viewBox: "0 0 32 32"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 19.108v.025a2.604 2.604 0 002.626 2.581h16.748A2.592 2.592 0 0027 19.163a2.547 2.547 0 00-1.452-2.336l-8.828-4.28v-1.16c.433-.39 1.271-1.155 1.548-1.478a2.357 2.357 0 00-2.481-3.797 2.328 2.328 0 00-1.517 1.443l-.042.146-.006.018-.003.017a.755.755 0 101.476.316l.006-.03a.865.865 0 011.408-.244.822.822 0 01.018 1.142c-.186.215-1.008.972-1.587 1.494a1.002 1.002 0 00-.33.746v1.421l-8.758 4.246A2.527 2.527 0 005 19.107zm2.626 1.115a1.088 1.088 0 01-.489-2.062L16 13.864l8.863 4.297a1.05 1.05 0 01.602.947v.028a1.09 1.09 0 01-1.091 1.087z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.01 3a13 13 0 11-13 13 13 13 0 0113-13m0-1a14 14 0 1014 14 14 14 0 00-14-14z"
}));

var Icon = function Icon(_ref) {
  var desc = _ref.desc,
      _ref$focusable = _ref.focusable,
      focusable = _ref$focusable === void 0 ? false : _ref$focusable,
      title = _ref.title,
      iconName = _ref.iconName,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: String(focusable),
    className: classNames('rds-svg--hanger-circle-icon', className)
  }, rest, svg.props), title && /*#__PURE__*/React.createElement("title", null, title), desc && /*#__PURE__*/React.createElement("desc", null, desc), svg.props.children);
};

Icon.propTypes = {
  desc: string,
  focusable: bool,
  title: string,
  iconName: string,
  className: string
};
Icon.displayName = 'HangerCircleIcon';
export default Icon;